import type { ProblemJson } from "@kestrel/http";
import type { ServerResult } from "@kestrel/stores";
import { headers, jsonMimes } from "../../../utils/mimes";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export async function decodeActionResultFromResponse(resp: Response): Promise<ServerResult> {
  /*                                                  */
  const contentType = `${resp.headers.get(headers[0])}`;
  if (!jsonMimes.some((m) => contentType.includes(m))) {
    return {
      type: "error",
      routeId: "",
      routePath: resp.url,
      error: {
        title: `bad content type returned: ${contentType}`,
        status: resp.status,
        detail: await resp.text(),
        contentType,
      },
    };
  }

  /*                                                                */
  const state: ProblemJson | ServerResult = (await resp.json()) as never;

  /*                                                                     */
  if (!resp.ok && "status" in state)
    return { type: "error", routeId: "", routePath: resp.url, error: state as ProblemJson };

  /*                                                        */
  return state as ServerResult;
}
